import Swiper, { Navigation, Pagination } from "swiper";
import { isFrontend } from "./helper";

export class DefaultSlider {
  constructor(sliderElement) {
    this.sliderElement = sliderElement;
    this.init();
  }

  init() {
    this.swiper = new Swiper(this.sliderElement, {
      modules: [Navigation, Pagination],
      createElements: true,
      navigation: true,
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
      loop: isFrontend(),
      simulateTouch: isFrontend(),
      draggable: isFrontend(),
    });
  }
}
